import React from "react";
import { DataProductList } from "../data_products/DataProductList"
import useCustomTable from "../tables/useCustomTable";

export default function DataVendorExtracts({onRowClick, extracts, onAdd, newButtonContent}) {

  const columns = [{
    Header: 'Stream',
    accessor: 'stream'
  },{
    Header: 'Data Type',
    accessor: 'data_type'
  },{
    Header: 'Created At',
    accessor: 'created_at',
    format: 'date',
    formatOptions: {dateFormat: "longShortMonth"}
  }];

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

  const dataProductListOptions = {
    onRowClick,
    columns,
    tableProps,
    paginationProps,
    tableSearchProps,
    onAdd,
    newButtonContent
  }

  return (
    <DataProductList {...dataProductListOptions} data={extracts} />
  )
}
